export interface AppConfig {
  [key: string]: any;
}

export interface ClientStatus {
  [key: string]: any;
}

export interface AppVersion {
  id?: number;
  version_name?: string;
  version_code?: number;
  platform?: string;
  update_type?: string;
  status?: string;
  release_notes?: string;
  download_url?: string;
  file_size?: number;
  file_md5?: string;
  channel?: string;
  min_support_version?: number;
  gray_enabled?: boolean;
  gray_percentage?: number;
  force_update?: boolean;
  create_time?: string;
  update_time?: string;
  created_at?: string;
  updated_at?: string;
  [key: string]: any;
}

export interface VersionListQuery {
  page?: number;
  pageSize?: number;
  platform?: string;
  status?: string;
  channel?: string;
  [key: string]: any;
}

export interface VersionListResponse {
  items: AppVersion[];
  total: number;
}

export interface VersionCheckRequest {
  version: string;
  versionCode: number;
  deviceId: string;
  channel?: string;
  osVersion?: string;
}

export interface UpdateInfo {
  hasUpdate: boolean;
  versionName?: string;
  versionCode?: number;
  updateType?: string;
  downloadUrl?: string;
  description?: string;
  fileMd5?: string;
  fileSize?: number;
}

export interface GrayDeviceWhitelist {
  id?: number;
  versionId?: number;
  deviceId?: string;
  createdAt?: string;
}

export interface CreateVersionRequest {
  version_name: string;
  version_code: number;
  platform?: string;
  update_type?: string;
  status?: string;
  release_notes?: string[];
  download_url?: string;
  file_size?: number;
  file_md5?: string;
  channel?: string;
  min_support_version?: string;
  gray_enabled?: boolean;
  gray_percentage?: number;
  force_update?: boolean;
  [key: string]: any;
}

export interface CozeWorkflow {
  [key: string]: any;
}

export interface CozeWorkspace {
  [key: string]: any;
}

export interface CozeWorkflowsResult {
  [key: string]: any;
}

export interface WorkflowParameter {
  [key: string]: any;
}

export interface MCPServerConfig {
  [key: string]: any;
}

export interface ToolCallRecord {
  [key: string]: any;
}

export const UpdateType = {
  OPTIONAL: "optional",
  FORCE: "forced",
  SILENT: "silent",
} as const;

export type UpdateTypeValue = (typeof UpdateType)[keyof typeof UpdateType];

export const PlatformType = {
  ANDROID: "android",
  IOS: "ios",
} as const;

export type PlatformTypeValue = (typeof PlatformType)[keyof typeof PlatformType];

export const VersionStatus = {
  DRAFT: "draft",
  PUBLISHED: "published",
  DISABLED: "disabled",
} as const;

export type VersionStatusValue = (typeof VersionStatus)[keyof typeof VersionStatus];

// ====== Missing types added for build ======

export interface ApiResponse<T = any> {
  success: boolean;
  message?: string;
  data?: T;
}

export interface ApiErrorResponse {
  success: false;
  message: string;
  code?: number;
  error?: string;
}

export interface ApiSuccessResponse<T = any> {
  success: true;
  message?: string;
  data: T;
}

export interface ToolCallLogsResponse {
  logs: ToolCallRecord[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ConnectionConfig {
  [key: string]: any;
}

export interface ModelScopeConfig {
  [key: string]: any;
}

export interface WebUIConfig {
  [key: string]: any;
}

export interface CozeUIState {
  [key: string]: any;
}

export interface CozeWorkflowsParams {
  [key: string]: any;
}

export interface MCPErrorCode {
  [key: string]: number;
}

export interface MCPServerAddRequest {
  [key: string]: any;
}

export interface MCPServerListResponse {
  servers: MCPServerConfig[];
  total: number;
}

export interface MCPServerStatus {
  name: string;
  status: string;
  tools_count?: number;
  error?: string;
}

export interface WorkflowParameterConfig {
  [key: string]: any;
}

export interface LocalMCPServerConfig extends MCPServerConfig {
  command?: string;
  args?: string[];
}

export interface SSEMCPServerConfig extends MCPServerConfig {
  url?: string;
}

export interface StreamableHTTPMCPServerConfig extends MCPServerConfig {
  url?: string;
}

// ====== Invitation Page Config ======

export interface PosterImage {
  url: string;
  title?: string;
  description?: string;
  link?: string;
  sortOrder: number;
  enabled?: boolean;
}

export interface InvitationPageConfig {
  posterImages?: PosterImage[];
  enabled?: boolean;
  layout?: 'carousel' | 'grid' | 'single';
  autoPlay?: boolean;
  interval?: number;
}
